import { getLocale } from './pathHelper';

export function flatten(arrays: Array<any[]>) {
  return [].concat.apply([], arrays);
}

export function uniq(array: Array<any>, objectKey = null) {
  if (objectKey == null) {
    return array.filter((elem, index, self) => self.indexOf(elem) === index);
  } else {
    return array.reduce((x, y) => x.findIndex((e: any) => e[objectKey] == y[objectKey]) < 0 ? [...x, y] : x, []);
  }
}

export function sleep(milliseconds: number = 500) {
  return new Promise<void>((resolve) => {
    setTimeout(() => { resolve(); }, milliseconds);
  });
};

export function priceWithCommas(n: number) {
  const locale = getLocale({ underscore: true });
  switch (locale.toString()) {
    case 'ja':
    case 'zh_tw':
    case 'zh_hk':
      return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    case 'zh_cn':
      return parseFloat(n.toString()).toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    default:
      return parseFloat(n.toString()).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}

export function isAuItem (): boolean {
  const url = document.location.pathname;
  const itemId = Number(url.split('/').pop());
  return itemId >= 5575 && itemId < 5804;
}

// 2022-23　https://github.com/wamazing/wamazing-snow/issues/5758
export function isOneAdultItem (): boolean {
  const url = document.location.pathname;
  return [5852, 5853, 5855, 5856, 5857, 5858, 5944, 6275, 6556].includes(Number(url.split('/').pop()));
}

export function isOneSeniorItem (): boolean {
  const url = document.location.pathname;
  return [5859, 6557].includes(Number(url.split('/').pop()));
}

export function isOneStudentItem (): boolean {
  const url = document.location.pathname;
  return [6558].includes(Number(url.split('/').pop()));
}

export function isOneChildItem (): boolean {
  const url = document.location.pathname;
  return [6559].includes(Number(url.split('/').pop()));
}